import React, { useEffect, useState } from "react";
import { Alert, Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import Tablexxx from "../Tablexxx";
import Creordvx from "./Creordvx";
import useCascada from "./useCascada";
import { columnsTracking, buttons } from "./configxx";
import { setFilters } from "../../libs/redux/slices/filterSlice/filterSlice";

/**
 * Parametrica "Orden de visualizacion" (Administrar > Orden Visualizacion, GEST0025).
 * Tracking con una fila por empresa y proceso parametrizados; Crear, Editar y Ver abren el
 * mismo modal con todos los tipos del proceso por seccion (padres, hijos y otros documentos).
 */
const FILTRO_BASE = "filters[REGESTXX]=ACTIVO";
const TITULOS = { CREAR: "CREAR ORDEN", EDITAR: "EDITAR ORDEN", VISUALIZAR: "VER ORDEN" };

const Tabsordv = () => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [component, setComponent] = useState("");
  const [row, setRow] = useState({});
  const [empresa, setEmpresa] = useState("");
  const [proceso, setProceso] = useState("");
  const { empresas, procesos } = useCascada(empresa, "", "");

  //Al entrar se limpia el filtro que haya dejado otra pantalla de Administrar
  useEffect(() => {
    dispatch(setFilters(FILTRO_BASE));
  }, [dispatch]);

  const handleFilter = () => {
    let filters = FILTRO_BASE;
    if (empresa) filters += `&filters[EMPNITXX]=${empresa}`;
    if (proceso) filters += `&filters[AREAIDXX]=${proceso}`;
    dispatch(setFilters(filters));
  };

  const handleClear = () => {
    setEmpresa("");
    setProceso("");
    dispatch(setFilters(FILTRO_BASE));
  };

  const combo = (id, label, valor, onChange, lista) => (
    <Col md={4}>
      <Form.Group controlId={id}>
        <Form.Label>{label}:</Form.Label>
        <Form.Control as="select" value={valor} onChange={(e) => onChange(e.target.value)}>
          <option value="">[SELECCIONE]</option>
          {lista.map((o) => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </Form.Control>
      </Form.Group>
    </Col>
  );

  return (
    <>
      <Modal show={show} onHide={() => setShow(false)} className="modal-xl">
        <Modal.Header closeButton>
          <Modal.Title>{TITULOS[component]}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Creordvx
            key={`${component}-${row?.EMPNITXX}-${row?.AREAIDXX}`}
            onClose={setShow}
            row={component === "CREAR" ? { EMPNITXX: empresa, AREAIDXX: proceso } : row}
            isCreating={component === "CREAR"}
            isEdit={component === "VISUALIZAR"}
          />
        </Modal.Body>
      </Modal>

      <Row className="mb-4">
        <Col md={4}>
          <Button className="w-100" onClick={() => { setComponent("CREAR"); setShow(true); }}>
            Crear Orden
          </Button>
        </Col>
      </Row>
      <Alert variant="light" className="border">
        Define en que orden se muestran los tipos documentales en la <b>consulta por numero de DO</b>:
        primero los documentos padre, cada uno seguido de sus hijos, y al final los demas documentos.
        Padres y otros documentos se numeran de 100 en 100 y los hijos con el orden del padre + 1,
        + 2... (factura 100, lista de empaque 101). Los tipos sin orden van despues, con el orden por
        defecto (transporte, factura y los demas por nombre). Quien es padre o hijo lo sigue
        definiendo la relacion padre-hijo de Tipo.
      </Alert>
      <Row className="mb-4">
        {combo("formEmpresaOrden", "Empresa", empresa, (v) => { setEmpresa(v); setProceso(""); }, empresas)}
        {combo("formProcesoOrden", "Proceso", proceso, setProceso, procesos)}
      </Row>
      <Row className="justify-content-end">
        <Col md={2}>
          <Button className="w-100" onClick={handleFilter}>Filtrar</Button>
        </Col>
        <Col md={2}>
          <Button className="w-100" onClick={handleClear}>Limpiar</Button>
        </Col>
      </Row>
      <Tablexxx
        columns={columnsTracking}
        URL={"ordentipos/procesos"}
        buttons={buttons}
        setComponent={setComponent}
        setShow={setShow}
        setRow={setRow}
      />
    </>
  );
};

export default Tabsordv;
